import { Component, Mixins, Prop } from 'vue-property-decorator';
import { UtilMixin } from '../../../UtilMixin';

type monthCounts = Array<{ year: number; month: number; count: number }>;

@Component({ components: {} })
export default class PurchasesCard extends Mixins(UtilMixin) {
  @Prop() public tenant?: string;
  @Prop({ default: false }) public plain?: boolean;
  @Prop({ default: 'ct-double-octave' }) public ratio?: string;

  public chartData(data: monthCounts) {
    return {
      labels: data
        .map((count) => this.formatMonthYear(count.year, count.month))
        .reverse(),
      series: [data.map((count) => count.count).reverse()],
    };
  }

  public chartOptions(data: monthCounts) {
    return {};
  }
}
